export default __webpack_public_path__ + "static/media/ibetologo.89112a3a.svg";